<ng-container *translateBlock="let t">
  @if (formData.formGroup) {
    <div class="input-wrapper"
         [formGroup]="formData.formGroup">

      @for (option of formData.options; track option.value) {
        <div class="input-item"
             (click)="onOptionClick(option.value)">
          <div class="top">
            @if (option.icon) {
              <span class="material-symbols-rounded upload-icon">
              {{ option.icon }}
            </span>
            }
            <label class="input-item-label">
              {{ getText(option.label) }}
            </label>
          </div>
          @if (option.description?.trim()) {
            <label class="input-item-description">
              {{ getText(option.description) }}
            </label>
          }
        </div>
      }

    </div>
  }
</ng-container>
